<!--
<mat-radio-group aria-label="Select an option" class="flex-right">
  <mat-radio-button value="1">SK</mat-radio-button>
  <mat-radio-button value="2">EN</mat-radio-button>
  <mat-radio-button value="3">SK, EN</mat-radio-button>
</mat-radio-group>
 -->

<div class="d-flex flex-column mb-3 container-fluid"
  style="background-color: rgb(0, 105, 200); border-radius: 4px;"
  [class.mat-elevation-z2]="true">

  <div class="row">
    <dl class="row mb-0 ms-3 mt-2" style="color: rgb(250, 250, 250)">

        <ng-container [ngSwitch]="data && this.idDruhDokumentu">
          <ng-container *ngSwitchCase="DOKUMENT_STUD_PROGRAM">
            <dt class="col-sm-3 d-none d-sm-block" i18n>Študijný program</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">
              {{data.studProgramSkratka}} - {{data.studProgramPopis}}
            </dd>

            <dt class="col-sm-3 d-none d-sm-block" i18n>Štúdium</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">
              <span i18n>Stupeň</span> - {{data.stupenStudiaKod}} - {{data.stupenStudiaPopis}},
              <span i18n>forma</span> - {{data.formaStudia}},
              <span i18n>typ</span> - {{data.typStudia}}
            </dd>
            <!-- <dd class="col-sm-7 d-none d-sm-block">Ib - Informatika</dd> -->
          </ng-container>
          <ng-container *ngSwitchCase="DOKUMENT_HABILITACNE_A_INAUGURACNE_KONANIE">
            <dt class="col-sm-3 d-none d-sm-block" i18n>Odbor habilitačného a inauguračného konania</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">
              {{data.studProgramSkratka}} - {{data.studProgramPopis}}
            </dd>

            <dt class="col-sm-3 d-none d-sm-block"> </dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block mb-3" i18n>
              habilitačné a inauguračné konanie
            </dd>
            <!-- <dd class="col-sm-7 d-none d-sm-block">Ib - Informatika</dd> -->
          </ng-container>
          <ng-container *ngSwitchCase="DOKUMENT_OSOBA">
            <dt class="col-sm-3 d-none d-sm-block" i18n>Meno a priezvisko</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">
              {{data.osobaMenoPriezvisko}}
            </dd>
          </ng-container>
          <ng-container *ngSwitchCase="DOKUMENT_PODPROGRAM">
            <dt class="col-sm-3 d-none d-sm-block" i18n>Podprogram, časť študijného programu</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">
              {{data.podprogramSkratka}} - {{data.podprogramPopis}}
            </dd>

            <dt class="col-sm-3 d-none d-sm-block mt-1" i18n>Štúdium</dt>
            <dd *ngIf="data" class="col-sm-8 d-none d-sm-block mt-1">
              {{getStudiumPrePodprogramPopis()}}
            </dd>
            <!-- <dd class="col-sm-7 d-none d-sm-block">Ib - Informatika</dd> -->
          </ng-container>
          <div *ngSwitchDefault></div>
        </ng-container>


      <dt class="col-sm-3 d-none d-sm-block" i18n>Typ dokumentu</dt>
      <dd *ngIf="data" class="col-sm-8 d-none d-sm-block">{{data.typDokumentu}}</dd>
      <!-- <dd class="col-sm-7 d-none d-sm-block">Opis študijného programu</dd> -->

    </dl>
  </div>

  <!-- RADIOBOX JAZYKOV -->
  <div class="me-2">
    <mat-radio-group
      (change)="onJazykChange()"
      aria-labelledby="example-radio-group-label"
      class="example-radio-group float-end"
      [(ngModel)]="jazyk"
      [disabled]="disabled">

      <mat-radio-button *ngFor="let kodJazyk of jazykyFormulara" class="example-radio-button"
          [value]="kodJazyk"  [matTooltip]="getRadioTooltip(kodJazyk)">
        <span class="text-radiobutton">{{kodJazyk}}</span>
      </mat-radio-button>

      <mat-radio-button *ngIf="jazykyFormulara.length > 1" #kombinaciaJazykov class="example-radio-button"
          [value]="jazykyFormularaString"
          [matTooltip]="getRadioTooltip(jazykyFormularaString)">
        <span class="text-radiobutton">{{jazykyFormularaString}}</span>
      </mat-radio-button>

    </mat-radio-group>
  </div>



</div>
